import Basketball from "./Ape-NFT/BasketballBoredApe.png";
import Bored from "./Ape-NFT/BoredApe.png";
import Captain from "./Ape-NFT/CaptainBoredApe.png";
import Chainz from "./Ape-NFT/ChainzBoredApe.png";
import ColdBlodded from "./Ape-NFT/ColdbloodedBoredApe.jpg";
import Cyclops from "./Ape-NFT/CyclopsBoredApe.jpg";
import Famous from "./Ape-NFT/FamousBoredApe.jpg";
import Fashion from "./Ape-NFT/FashionBoredApe.jpg";
import Football from "./Ape-NFT/FootballBoredApe.webp";
import Happy from "./Ape-NFT/HappyBeastBoredApe.png";
import Lover from "./Ape-NFT/LoverBoredApe.png";
import Machine from "./Ape-NFT/MachineBoredApe.png";
import Monk from "./Ape-NFT/MonkBoredApe.jpg";
import Nanny from "./Ape-NFT/NannyBoredApe.jpg";
import Obsidian from "./Ape-NFT/ObsidianBoredApe.jpg";
import Old from "./Ape-NFT/OldBoredApe.png";
import Space from "./Ape-NFT/SpaceBoredApe.png";
import Surprised from "./Ape-NFT/SurprisedBoredApe.png";
import Talent from "./Ape-NFT/TalentBored.png";
import Weed from "./Ape-NFT/WeedBoredApe.png";
import Yatch from "./Ape-NFT/YachtBoredApe.jpg";
import Waterfall from "../PolygonArt/Polygonart-NFT/Waterfall.jpg";
import Artist from "./Ape-NFT/avatar.png";
const items = [
  {
    id: 1,
    title: "Suprised Ape",
    artist: "David",
    artistImage: Artist,
    image: Surprised,
    info: "Digital art of Surprised Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 2,
    title: "Basketball Ape",
    artist: "David",
    artistImage: Artist,
    image: Basketball,
    info: "Digital art of Basketball Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 3,
    title: "Bored Ape",
    artist: "David",
    artistImage: Artist,
    image: Bored,
    info: "Digital art of Bored Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 4,
    title: "Captain Ape",
    artist: "David",
    artistImage: Artist,
    image: Captain,
    info: "Digital art of Captain Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 5,
    title: "2Chainz Ape",
    artist: "David",
    artistImage: Artist,
    image: Chainz,
    info: "Digital art of 2Chainz Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 6,
    title: "ColdBlooded Ape",
    artist: "David",
    artistImage: Artist,
    image: ColdBlodded,
    info: "Digital art of ColdBlooded Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 7,
    title: "Cyclops Ape",
    artist: "David",
    artistImage: Artist,
    image: Cyclops,
    info: "Digital art of Cyclops Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 8,
    title: "Famous Ape",
    artist: "David",
    artistImage: Artist,
    image: Famous,
    info: "Digital art of Famous Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 9,
    title: "Fashion Ape",
    artist: "David",
    artistImage: Artist,
    image: Fashion,
    info: "Digital art of Fashion Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 10,
    title: "Football Ape",
    artist: "David",
    artistImage: Artist,
    image: Football,
    info: "Digital art of Football Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 11,
    title: "Happy Ape",
    artist: "David",
    artistImage: Artist,
    image: Happy,
    info: "Digital art of Happy Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },

  {
    id: 12,
    title: "Lover Ape",
    artist: "David",
    artistImage: Artist,
    image: Lover,
    info: "Digital art of Lover Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    collection: "Ape Collection",
  },
  {
    id: 13,
    title: "Machine Ape",
    artist: "David",
    artistImage: Artist,
    image: Machine,
    info: "Digital art of Machine Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 14,
    title: "Monk Ape",
    artist: "David",
    artistImage: Artist,
    image: Monk,
    info: "Digital art of Monk Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 15,
    title: "Nanny Ape",
    artist: "David",
    artistImage: Artist,
    image: Nanny,
    info: "Digital art of Nanny Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 16,
    title: "Obsidian Ape",
    artist: "David",
    artistImage: Artist,
    image: Obsidian,
    info: "Digital art of Obsidian Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 17,
    title: "Old Ape",
    artist: "David",
    artistImage: Artist,
    image: Old,
    info: "Digital art of Old Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 18,
    title: "Space Ape",
    artist: "David",
    artistImage: Artist,
    image: Space,
    info: "Digital art of Space Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],

    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 19,
    title: "Talent Ape",
    artist: "David",
    artistImage: Artist,
    image: Talent,
    info: "Digital art of Talent Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    post: "Digital Creative Artist",
    collection: "Ape Collection",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 20,
    title: "High Ape",
    artist: "David",
    artistImage: Artist,
    image: Weed,
    info: "Digital art of High Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
  {
    id: 21,
    title: "Yatch Ape",
    artist: "David",
    artistImage: Artist,
    image: Yatch,
    info: "Digital art of Yatch Ape from our Ape collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Ape Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Ape Collection", pic: Space },
      { id: 2, name: "PolygonArt Collection", pic: Waterfall },
    ],
    artistStory:
      "David a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. David has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Davids Works via his social media pages to know more about him ",
  },
];
export default items;
